import React from "react";
import { useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import { useWhiteLabel } from "@lib/context";
import { AppContext } from "@lib/types/Context";
import { SharedCustomers } from "@app/shared";
import { NoPermission } from "@lib/components/AppComponents";

const CustomerList: React.FC = () => {
  const { customerId } = useParams();
  const { messages } = useIntl();
  const { permissions } = useWhiteLabel();

  // Check if user has permission to view wallet pool
  if (!permissions.canViewWalletPool) {
    return <NoPermission />;
  }

  return (
    <SharedCustomers
      context={AppContext.CUSTOMER}
      customerId={customerId}
      customTitle={
        messages["sidebar.whiteLabelTransactions.whiteLabels"] as string
      }
    />
  );
};

export default CustomerList;
